
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { UpdateWorkNameDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const UpdateWorkNameDDL = (props) => {
    const { WorkName, setWorkName, Flag, rowData,ProjectName, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    // const [workTypeID, setworkTypeID] = useState('')
    useEffect(() => {
        const data = {
            M_ProjectID:ProjectName.ID,
            M_UserID: UserID,
            token: token
        }
        dispatch(UpdateWorkNameDDLAPI({ data }))
    }, [ProjectName.ID, IsPost])

    const { UpdateWorkNameData } = useSelector(state => state.UpdateWorkNameDDL)

    useEffect(() => {
        handleWorkNameDDL()
    }, [UpdateWorkNameData])

    const handleWorkNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (UpdateWorkNameData && UpdateWorkNameData.table && UpdateWorkNameData.table.length > 0) {
            let list = UpdateWorkNameData.table.map((item, index) => ({
                value: item.m_WorkID,
                label: item.workname,
            }))
            setWorkName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_WorkID : 0,
                Label: Flag === 'Update' ? rowData.workname : "Select...",
            })
        }
        else {
            setWorkName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Work Name {Flag && <AstricSign />} </b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkName.ID, label: WorkName.Label }}
                onChange={(e) => {
                    e ?
                        setWorkName({ ...WorkName, ID: e.value, Label: e.label })
                        :
                        setWorkName({ ...WorkName, ID: 0, Label: "Select..." })

                }}
                options={WorkName.DDL}
            />
        </div>
    )
}
